import React from "react";

const SprinkledStars = () => {
  return (
    <>
      {/* Stars for Desktop screen */}
      <svg
        className="sprinkled-star-1 desktop-only"
        width="37"
        height="41"
        viewBox="0 0 37 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M34.6189 25.6082L26.3287 20.8211L34.6189 16.034C36.4485 14.9779 37.0762 12.6377 36.0201 10.8067C34.964 8.97706 32.6238 8.34935 30.7928 9.40679L22.5026 14.1939V4.62095C22.5026 2.50738 20.7888 0.794922 18.6766 0.794922C16.5643 0.794922 14.8505 2.50868 14.8505 4.62095V14.1939L6.56031 9.40679C4.73063 8.35066 2.39047 8.97706 1.33303 10.8067C0.276896 12.6364 0.90329 14.9766 2.73297 16.034L11.0232 20.8211L2.73297 25.6082C0.90329 26.6643 0.275594 29.0045 1.33303 30.8355C2.38917 32.6651 4.72933 33.2929 6.56031 32.2368L14.8505 27.4496V37.0226C14.8505 39.1361 16.563 40.8486 18.6766 40.8486C20.7901 40.8486 22.5026 39.1361 22.5026 37.0226V27.4496L30.7928 32.2368C32.6225 33.2929 34.9627 32.6664 36.0201 30.8355C37.0762 29.0058 36.4485 26.6656 34.6189 25.6082Z"
          fill="white"
        />
      </svg>

      <svg
        className="sprinkled-star-2 desktop-only"
        width="27"
        height="30"
        viewBox="0 0 27 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24.8294 18.2679L18.8616 14.8218L24.8294 11.3757C26.1465 10.6154 26.5984 8.93078 25.8381 7.61271C25.0778 6.29558 23.3932 5.84377 22.0752 6.60498L16.1073 10.0511V3.15977C16.1073 1.63827 14.8745 0.405518 13.353 0.405518C11.8315 0.405518 10.5988 1.63827 10.5988 3.15977V10.0511L4.63085 6.60498C3.31372 5.8447 1.6291 6.29558 0.868816 7.61271C0.108535 8.92984 0.559465 10.6145 1.8766 11.3757L7.8445 14.8218L1.8766 18.2679C0.559465 19.0282 0.107597 20.7128 0.868816 22.03C1.6291 23.3471 3.31372 23.799 4.63085 23.0377L10.5988 19.5926V26.4838C10.5988 28.0053 11.8315 29.2381 13.353 29.2381C14.8745 29.2381 16.1073 28.0053 16.1073 26.4838V19.5926L22.0752 23.0377C23.3923 23.798 25.0769 23.3471 25.8381 22.03C26.5984 20.7138 26.1465 19.0291 24.8294 18.2679Z"
          fill="white"
        />
      </svg>

      <svg
        className="sprinkled-star-3 desktop-only"
        width="31"
        height="35"
        viewBox="0 0 31 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.0506 21.2927L22.0589 17.2553L29.0506 13.218C30.5937 12.3273 31.1231 10.3536 30.2324 8.80941C29.3417 7.26631 27.368 6.73692 25.8238 7.62873L18.8321 11.6661V3.59251C18.8321 1.80997 17.3867 0.365723 15.6053 0.365723C13.8227 0.365723 12.3785 1.80997 12.3785 3.59251V11.6661L5.38672 7.62873C3.84362 6.73801 1.86998 7.26631 0.978162 8.80941C0.0874433 10.3525 0.615721 12.3262 2.15883 13.218L9.15059 17.2553L2.15883 21.2927C0.615721 22.1834 0.086345 24.157 0.978162 25.7001C1.86888 27.2433 3.84252 27.7726 5.38672 26.8808L12.3785 22.8435V30.9171C12.3785 32.6996 13.8227 34.1438 15.6053 34.1438C17.3878 34.1438 18.8321 32.6996 18.8321 30.9171V22.8435L25.8238 26.8808C27.3669 27.7716 29.3406 27.2433 30.2324 25.7001C31.1231 24.157 30.5937 22.1834 29.0506 21.2927Z"
          fill="white"
        />
      </svg>

      <svg
        className="sprinkled-star-4 desktop-only"
        width="33"
        height="37"
        viewBox="0 0 33 37"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M30.5402 22.5138L23.1357 18.2381L30.5402 13.9624C32.1744 13.0191 32.735 10.9289 31.7917 9.29473C30.8484 7.66052 28.7583 7.09994 27.1229 8.04441L19.7184 12.3201V3.76982C19.7184 1.88205 18.1888 0.352539 16.301 0.352539C14.4133 0.352539 12.8837 1.88205 12.8837 3.76982V12.3201L5.47925 8.04441C3.84505 7.10111 1.75484 7.66052 0.810375 9.29473C-0.132929 10.9289 0.426554 13.0191 2.06076 13.9624L9.46533 18.2381L2.06076 22.5138C0.426554 23.4572 -0.134092 25.5473 0.810375 27.1827C1.75368 28.8169 3.84388 29.3775 5.47925 28.433L12.8837 24.1573V32.7076C12.8837 34.5953 14.4133 36.1248 16.301 36.1248C18.1888 36.1248 19.7184 34.5953 19.7184 32.7076V24.1573L27.1229 28.433C28.7571 29.3763 30.8472 28.8169 31.7917 27.1827C32.735 25.5484 32.1744 23.4583 30.5402 22.5138Z"
          fill="white"
        />
      </svg>

      {/* <svg
        className="sprinkled-star-5 desktop-only"
        width="46"
        height="51"
        viewBox="0 0 46 51"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M42.8146 31.1962L32.543 25.2649L42.8146 19.3337C45.0816 18.0252 45.8593 15.1256 44.5508 12.857C43.2422 10.5901 40.3427 9.81242 38.0741 11.1226L27.8025 17.0538V5.19287C27.8025 2.57414 25.6792 0.452393 23.0621 0.452393C20.4434 0.452393 18.3216 2.57414 18.3216 5.19287V17.0538L8.04996 11.1226C5.78298 9.81404 2.8835 10.5901 1.57494 12.857C0.266388 15.124 1.04251 18.0236 3.30949 19.3337L13.5811 25.2649L3.30949 31.1962C1.04251 32.5048 0.264774 35.4042 1.57494 37.6728C2.8835 39.9398 5.78298 40.7175 8.04996 39.4074L18.3216 33.4762V45.337C18.3216 47.9557 20.4434 50.0776 23.0621 50.0776C25.6808 50.0776 27.8025 47.9557 27.8025 45.337V33.4762L38.0741 39.4074C40.3411 40.7159 43.2406 39.9398 44.5508 37.6728C45.8593 35.4058 45.0816 32.5064 42.8146 31.1962Z"
          fill="white"
        />
      </svg> */}
      {/* Stars for Mobile screen */}
      <svg
        className="sprinkled-star-1 mobile-only"
        width="12"
        height="14"
        viewBox="0 0 12 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.205 8.36195L8.62295 6.87095L11.205 5.37994C11.7749 5.05099 11.9704 4.32212 11.6415 3.75184C11.3125 3.18196 10.5836 2.98646 10.0134 3.31581L7.43127 4.8068V1.8252C7.43127 1.1669 6.89749 0.63353 6.2396 0.63353C5.58171 0.63353 5.04793 1.1673 5.04793 1.8252V4.8068L2.46584 3.31581C1.89596 2.98686 1.16708 3.18196 0.837731 3.75184C0.508784 4.32172 0.703883 5.05058 1.27376 5.37994L3.85585 6.87095L1.27376 8.36195C0.703883 8.6909 0.508379 9.41976 0.837731 9.99005C1.16668 10.5599 1.89555 10.7554 2.46584 10.4265L5.04793 8.93548V11.9171C5.04793 12.5754 5.5813 13.1088 6.2396 13.1088C6.8979 13.1088 7.43127 12.5754 7.43127 11.9171V8.93548L10.0134 10.4265C10.5832 10.7554 11.3121 10.5603 11.6415 9.99005C11.9704 9.42017 11.7749 8.6913 11.205 8.36195Z"
          fill="white"
        />
      </svg>

      <svg
        className="sprinkled-star-2 mobile-only"
        width="9"
        height="10"
        viewBox="0 0 9 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.48841 5.96866L6.62965 4.89532L8.48841 3.82199C8.89865 3.58519 9.03939 3.06049 8.80259 2.64996C8.56579 2.23972 8.0411 2.09899 7.63057 2.33609L5.77179 3.40941V1.26303C5.77179 0.789138 5.38783 0.405182 4.91394 0.405182C4.44005 0.405182 4.05609 0.789138 4.05609 1.26303V3.40941L2.19731 2.33609C1.78707 2.09929 1.26238 2.23972 1.02558 2.64996C0.788778 3.06019 0.929226 3.5849 1.33946 3.82199L3.19825 4.89532L1.33946 5.96866C0.929226 6.20546 0.788486 6.73015 1.02558 7.14039C1.26238 7.55063 1.78707 7.69137 2.19731 7.45428L4.05609 6.38124V8.5276C4.05609 9.00149 4.44005 9.38547 4.91394 9.38547C5.38783 9.38547 5.77179 9.00149 5.77179 8.5276V6.38124L7.63057 7.45428C8.04081 7.69108 8.56549 7.55063 8.80259 7.14039C9.03939 6.73045 8.89865 6.20575 8.48841 5.96866Z"
          fill="white"
        />
      </svg>

      <svg
        className="sprinkled-star-3 mobile-only"
        width="10"
        height="11"
        viewBox="0 0 10 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.47234 6.68443L7.29467 5.42694L9.47234 4.16947C9.95296 3.89205 10.1178 3.27732 9.84042 2.79636C9.56299 2.31573 8.94828 2.15085 8.46732 2.42862L6.28964 3.68611V1.17148C6.28964 0.616288 5.83947 0.166458 5.28462 0.166458C4.72942 0.166458 4.27959 0.616288 4.27959 1.17148V3.68611L2.10191 2.42862C1.62129 2.15119 1.00658 2.31573 0.72881 2.79636C0.451384 3.27698 0.615923 3.8917 1.09654 4.16947L3.27422 5.42694L1.09654 6.68443C0.615923 6.96186 0.451042 7.57657 0.72881 8.05719C1.00624 8.53782 1.62095 8.7027 2.10191 8.42493L4.27959 7.16744V9.68207C4.27959 10.2373 4.72942 10.6871 5.28462 10.6871C5.83981 10.6871 6.28964 10.2373 6.28964 9.68207V7.16744L8.46732 8.42493C8.94794 8.70236 9.56265 8.53782 9.84042 8.05719C10.1178 7.57657 9.95296 6.96186 9.47234 6.68443Z"
          fill="white"
        />
      </svg>

      <svg
        className="sprinkled-star-4 mobile-only"
        width="11"
        height="12"
        viewBox="0 0 11 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.3455 7.1952L8.03928 5.86347L10.3455 4.53174C10.8545 4.23793 11.0291 3.58693 10.7353 3.07793C10.4415 2.56894 9.7905 2.39434 9.28115 2.6885L6.97492 4.02021V1.35713C6.97492 0.769157 6.49851 0.29277 5.91054 0.29277C5.32257 0.29277 4.84618 0.769157 4.84618 1.35713V4.02021L2.53996 2.6885C2.03096 2.3947 1.37994 2.56894 1.08577 3.07793C0.79197 3.58693 0.966228 4.23793 1.47522 4.53174L3.78147 5.86347L1.47522 7.1952C0.966228 7.489 0.791608 8.14 1.08577 8.64936C1.37958 9.15835 2.0306 9.33297 2.53996 9.03881L4.84618 7.70708V10.3702C4.84618 10.9581 5.32257 11.4345 5.91054 11.4345C6.49851 11.4345 6.97492 10.9581 6.97492 10.3702V7.70708L9.28115 9.03881C9.79014 9.33261 10.4411 9.15835 10.7353 8.64936C11.0291 8.14036 10.8545 7.48936 10.3455 7.1952Z"
          fill="white"
        />
      </svg>

      {/* <svg
        className="sprinkled-star-5 mobile-only"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.3822 10.022L10.183 8.17466L13.3822 6.32731C14.0883 5.91974 14.3305 5.01664 13.923 4.31006C13.5154 3.60398 12.6123 3.36178 11.9057 3.76984L8.70652 5.6172V1.92295C8.70652 1.10732 8.04517 0.446472 7.23004 0.446472C6.4144 0.446472 5.75354 1.10732 5.75354 1.92295V5.6172L2.55432 3.76984C1.84824 3.36228 0.945158 3.60398 0.537591 4.31006C0.130025 5.01614 0.371757 5.91924 1.07784 6.32731L4.27706 8.17466L1.07784 10.022C0.371757 10.4296 0.129522 11.3327 0.537591 12.0393C0.945158 12.7453 1.84824 12.9876 2.55432 12.5795L5.75354 10.7322V14.4264C5.75354 15.242 6.4144 15.9029 7.23004 15.9029C8.04567 15.9029 8.70652 15.242 8.70652 14.4264V10.7322L11.9057 12.5795C12.6118 12.9871 13.5149 12.7453 13.923 12.0393C14.3305 11.3332 14.0883 10.4301 13.3822 10.022Z"
          fill="white"
        />
      </svg> */}
    </>
  );
};

export default SprinkledStars;
